import { HandSeats } from '@/models/games/blackjack2/SeatCardInfo';
import { RootState } from '@/store/store';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { bj2HandsReducer } from './handReducer';

// slice
export const BJ2_HAND_KEY = 'app::bj2::hand';
export const bj2HandsAdapter = createEntityAdapter<HandSeats, number>({
    selectId: br => br.HostId,
    sortComparer: (a, b) => a.HostId - b.HostId,
});
const initialBj2HandsState = bj2HandsAdapter.getInitialState();
const bj2HandsSlice = createSlice({
    name: BJ2_HAND_KEY,
    initialState: initialBj2HandsState,
    reducers: {
        init: bj2HandsAdapter.upsertOne,
        update: bj2HandsAdapter.updateOne,
        ...bj2HandsReducer,
    },
});
export const bj2HandSliceReducer = bj2HandsSlice.reducer;
export const bj2HandSliceActions = bj2HandsSlice.actions;
// selector
export const getBj2HandsSelectors = bj2HandsAdapter.getSelectors<RootState>(
    state => state[BJ2_HAND_KEY]
);
export const getSeatHands = getBj2HandsSelectors.selectById;
